import type { Dict } from './en';

export const es: Dict = {
  appTagline: 'Rastreador de vuelos en vivo, abierto',
  search: 'Buscar vuelo, matrícula, hex o aeropuerto',
  searchNoResults: 'No se encontró nada cerca ni en la red.',
  searchUpstream: 'Buscando en la red…',
  filters: 'Filtros',
  layers: 'Mapa',
  settings: 'Ajustes',
  about: 'Acerca de y datos',
  close: 'Cerrar',
  aircraft: 'Aeronaves',
  inView: 'a la vista',
  ground: 'En tierra',
  altitude: 'Altitud',
  geoAltitude: 'Altitud GPS',
  speed: 'Velocidad sobre el suelo',
  vs: 'Velocidad vertical',
  track: 'Rumbo',
  squawk: 'Squawk',
  registration: 'Matrícula',
  type: 'Tipo',
  category: 'Categoría',
  hex: 'ICAO 24 bits',
  source: 'Fuente de posición',
  positionAge: 'Antigüedad de la posición',
  provider: 'Proveedor de datos',
  route: 'Ruta',
  routeUnknown: 'No hay ruta registrada para este indicativo.',
  routeImplausible: 'Hay una ruta registrada para este indicativo, pero no coincide con la posición actual de la aeronave, así que se oculta.',
  routeNote: 'Ruta habitual de este indicativo (datos de la comunidad). No es un horario en vivo.',
  follow: 'Seguir',
  unfollow: 'Dejar de seguir',
  share: 'Copiar enlace',
  copied: 'Enlace copiado',
  trail: 'La estela muestra las posiciones recibidas desde que empezaste a observar.',
  emergency: 'Emergencia',
  military: 'Militar',
  noCallsign: 'Sin indicativo',
  zoomIn: 'Acerca el mapa para cargar aeronaves de toda la zona. Solo se muestra el centro.',
  stale: 'Datos en vivo retrasados: la red comunitaria está limitando o no disponible. Se muestran las últimas posiciones conocidas.',
  offline: 'Estás sin conexión. Las posiciones se reanudarán cuando vuelva la conexión.',
  loading: 'Cargando aeronaves en vivo…',
  errorData: 'No se pudo contactar con la API de Skywake.',
  apiNotConfigured: 'Esta versión no tiene configurada una API de datos en vivo, así que no se pueden mostrar aeronaves.',
  retry: 'Reintentar',
  dataAge: 'Antigüedad de los datos',
  providerStatus: 'Estado del proveedor',
  ok: 'OK',
  degraded: 'Degradado',
  theme: 'Tema',
  themeAuto: 'Sistema',
  themeLight: 'Claro',
  themeDark: 'Oscuro',
  units: 'Unidades',
  language: 'Idioma',
  labels: 'Etiquetas de indicativo',
  airports: 'Aeropuertos',
  trails: 'Estela de la aeronave seleccionada',
  colorBy: 'Colorear aeronaves por',
  colorAlt: 'Altitud',
  colorSource: 'Fuente de posición',
  altMin: 'Altitud mín. (ft)',
  altMax: 'Altitud máx. (ft)',
  speedMin: 'Velocidad mín. (kt)',
  speedMax: 'Velocidad máx. (kt)',
  callsignPrefixes: 'Prefijos de aerolínea / indicativo',
  callsignPrefixesHint: 'Separados por comas, p. ej. IBE, VLG, RYR',
  types: 'Tipos de aeronave',
  typesHint: 'Códigos OACI, * como comodín, p. ej. A32*, B738',
  hideGround: 'Ocultar aeronaves en tierra',
  onlyEmergency: 'Solo emergencias (7500/7600/7700)',
  onlyMilitary: 'Solo militares',
  sources: 'Fuentes de posición',
  presets: 'Ajustes guardados',
  presetName: 'Nombre del ajuste',
  savePreset: 'Guardar los filtros actuales',
  apply: 'Aplicar',
  delete: 'Eliminar',
  clearFilters: 'Borrar filtros',
  filtered: 'filtradas',
  airport: 'Aeropuerto',
  elevation: 'Elevación',
  nearbyTraffic: 'Tráfico a menos de 30 km',
  noNearby: 'Ahora mismo no hay aeronaves rastreadas cerca de este aeropuerto.',
  viewOnOurAirports: 'Ver en OurAirports',
  bookmarks: 'Marcadores',
  bookmarkView: 'Guardar esta vista',
  watchlist: 'Vigilar',
  watching: 'Vigilando',
  alerts: 'Alertas',
  alertsEmergency: 'Avisarme de squawks de emergencia a la vista',
  alertsWatch: 'Avisarme cuando aparezcan aeronaves vigiladas',
  alertsPermissionDenied: 'Tu navegador bloquea las notificaciones. Las alertas solo se mostrarán dentro de la app.',
  emergencyAlert: 'Squawk de emergencia',
  watchAlert: 'Aeronave vigilada detectada',
  adsb: 'ADS-B',
  mlat: 'MLAT',
  tisb: 'TIS-B',
  adsr: 'ADS-R',
  modes: 'Modo S',
  other: 'Otra',
  attribution: 'Datos de aeronaves: colaboradores de ADSB.lol (ODbL 1.0). Rutas: VRS standing data (CC0). Aeropuertos: OurAirports (dominio público). Fotos: fotógrafos de Planespotters.net (acreditados en cada foto). Meteorología: NOAA Aviation Weather Center (dominio público).',
  aboutBody:
    'Skywake es software libre y de código abierto. Las posiciones proceden de receptores ADS-B voluntarios agregados por ADSB.lol; la cobertura depende de dónde haya voluntarios con receptores. Sin cuentas, sin anuncios y sin cookies de seguimiento. Tus ajustes se quedan en este dispositivo.',
  limitations: 'Limitaciones conocidas',
  limitationsList:
    'Aún no hay historial ni reproducción: Skywake solo muestra lo recibido desde que lo abriste.|Las rutas vienen de una base de datos comunitaria de indicativos y pueden ser incorrectas o estar desactualizadas.|La cobertura es escasa sobre los océanos y en regiones con pocos receptores.|Las aeronaves cuyos propietarios pidieron privacidad (p. ej. LADD/PIA) pueden estar ocultas o anonimizadas.',
  sourceCode: 'Código fuente',
  feedData: 'Instala un receptor y aporta datos a ADSB.lol',
  version: 'Versión',
  webglMissing: 'Tu navegador no puede dibujar el mapa en vivo (WebGL2 no disponible).',
  selectedOutOfCoverage: 'Esta aeronave ya no se está recibiendo.',
  emergencies: 'Emergencias',
  compare: 'Comparar',
  list: 'Lista',
  sortBy: 'Ordenar por',
  callsign: 'Indicativo',
  locate: 'Mi ubicación',
  photoAlt: 'Foto de la aeronave {reg}',
  weather: 'Tiempo (METAR)',
  weatherUnavailable: 'El tiempo no está disponible ahora mismo.',
  weatherNone: 'Este aeropuerto no publica METAR.',
  weatherSource: 'NOAA Aviation Weather Center. No apto para planificar vuelos.',
  wind: 'Viento',
  calm: 'Calma',
  variable: 'Variable',
  gusts: 'rachas',
  visibility: 'Visibilidad',
  temperature: 'Temp. / punto de rocío',
  clouds: 'Nubes',
  observed: 'Antigüedad del informe',
  legFlown: 'recorridos',
  legToGo: 'restantes',
  legEta: 'Llegada',
  legNote: 'Estimación por ortodrómica a partir de la ruta habitual y la velocidad actual.',
};
